module.exports = __webpack_public_path__ + "static/img/grade_7.ad4be04.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_7.png
// module id = Y1GV
// module chunks = 89